var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    stroke: "#179CF0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 28.4374V23.0974C16.025 22.6996 16.183 22.3181 16.4643 22.0368C16.7456 21.7554 17.1272 21.5974 17.525 21.5974H42.125C42.5228 21.5974 42.9044 21.7554 43.1857 22.0368C43.467 22.3181 43.625 22.6996 43.625 23.0974V40.3474C43.625 40.7452 43.467 41.1268 43.1857 41.4081C42.9044 41.6894 42.5228 41.8474 42.125 41.8474H17.525C17.1272 41.8474 16.7456 41.6894 16.4643 41.4081C16.183 41.1268 16.025 40.7452 16.025 40.3474V34.9999",
    stroke: "#179CF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 28.4375H23.75C24.1478 28.4375 24.5294 28.5955 24.8107 28.8768C25.092 29.1581 25.25 29.5397 25.25 29.9375V33.5C25.25 33.8978 25.092 34.2794 24.8107 34.5607C24.5294 34.842 24.1478 35 23.75 35H15.125C14.9261 35 14.7353 34.921 14.5947 34.7803C14.454 34.6397 14.375 34.4489 14.375 34.25V29.1875C14.375 28.9886 14.454 28.7978 14.5947 28.6572C14.7353 28.5165 14.9261 28.4375 15.125 28.4375Z",
    stroke: "#179CF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8675 33.2224C22.6959 33.2224 23.3675 32.5508 23.3675 31.7224C23.3675 30.894 22.6959 30.2224 21.8675 30.2224C21.0391 30.2224 20.3675 30.894 20.3675 31.7224C20.3675 32.5508 21.0391 33.2224 21.8675 33.2224Z",
    stroke: "#179CF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.59 21.5976L20.8925 16.1526L19.31 21.5976",
    stroke: "#179CF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.32640d05085f9da9fc6f3f579c06bd8b.svg";
export { ForwardRef as ReactComponent };